import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { profileKeys } from '@core/react-query/features/profile'
import { checkInKeys } from '@core/react-query/features/checkIn'
import { ICheckInSession } from '@core/entities/checkIn'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useForceCheckOutPermitUsers = (
  options: UseMutationOptions<
    ICheckInSession[],
    RequestErrorType,
    RequestTypes['forceCheckOut']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    ...permitKeys.forceCheckOut,
    onSuccess: (_, variables, context) => {
      queryClient.invalidateQueries(
        permitKeys.byId({ permitId: variables.permitId }).queryKey,
      )
      queryClient.invalidateQueries(dashboardKeys.getDashboardPermitStats._def)
      queryClient.invalidateQueries(profileKeys.getUserStats._def)
      queryClient.invalidateQueries(checkInKeys.openSessions._def)
      options.onSuccess?.(_, variables, context)
    },
  })
}
